import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["children", "sliderSettings"];
import { isBrowser } from '@migros/msrc-browser';
import { Box, styled } from '@migros/msrc-ui-kit';
import React from 'react';
import ReactSlick from 'react-slick';
import { ListStyleType, TileLayout } from '../../helpers';
import SlickSliderStyles from './slickSliderStyles';
export const Slider = _ref => {
  let {
      children,
      sliderSettings
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (isBrowser()) {
    return /*#__PURE__*/React.createElement(StyledSlider, rest, /*#__PURE__*/React.createElement(SlickSliderStyles, null), /*#__PURE__*/React.createElement(ReactSlick, sliderSettings, children));
  }
  return null;
};
const StyledSlider = styled(Box)`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .slick-list {
    ${({
  theme,
  layout
}) => {
  if (layout === TileLayout.mini) {
    return `margin: 0 ${theme.spacings.medium};`;
  }
  return null;
}}
  }

  .slick-slider {
    padding: 0 ${({
  theme: {
    spacings
  }
}) => spacings.huge};
  }

  .slick-slide {
    padding-top: ${({
  theme: {
    spacings
  }
}) => spacings.medium};
    padding-bottom: ${({
  theme: {
    spacings
  }
}) => spacings.medium};
    padding-left: ${({
  theme: {
    spacings
  }
}) => spacings.xtiny};
    padding-right: ${({
  theme: {
    spacings
  }
}) => spacings.xtiny};
  }

  .slick-active {
    margin: 0 ${({
  mode
}) => mode === ListStyleType.fancy ? '-1.5px' : '-0.5px'};
  }

  .slider {
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .slider > div {
    width: ${({
  tilesVisibleMobile
}) => `${100 / tilesVisibleMobile}%`};
    flex: 0 0 auto;
  }
`;